import { wordOne } from "./wordPractice1";
import { wordTwo } from "./wordPractice2";
import { wordThree } from "./wordPractice3";
import { wordFour } from "./wordPractice4";
import { wordFive } from "./wordPractice5";
import { wordSix } from "./wordPractice6";
import { wordSeven } from "./wordPractice7";
import { wordEight } from "./wordPractice8";
import { wordNine } from "./wordPractice9";
import { wordTen } from "./wordPractice10";

export const words = {
  one: wordOne,
  two: wordTwo,
  three: wordThree,
  four: wordFour,
  five: wordFive,
  six: wordSix,
  seven: wordSeven,
  eight: wordEight,
  nine: wordNine,
  ten: wordTen,
};
